import http from "../../http";
import { API_URLs } from "../../CONSTANTS";

const b2b_apis = API_URLs.B2B;

export const apiCall_getProducerProducts = async () => {
  return http.get(b2b_apis.getProducerProducts);
};

export const apiCall_getProducerProductDetails = async (productId) => {
  return http.get(
    b2b_apis.getProducerProductDetails + "?ProductId=" + productId
  );
};

export const apiCall_getOrderPaymentDetails = async () => {
  return http.get(b2b_apis.getOrderPaymentDetails);
};

export const apiCall_submitOrder = async (data) => {
  return http.post(b2b_apis.submitOrder, data);
};
